import React, { useEffect, useState, useContext, useRef } from "react";
import { useMutation } from "graphql-hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { REFRESH_TOKEN_MUTATION } from "./graphQL/user_qry";
import { ClientContext } from "graphql-hooks";

const admin_string = process.env.REACT_APP_ADMIN_URL || "/t31u4YYky50K";

const AuthWrapper = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const client = useContext(ClientContext);
  const [loadContent, setLoadContent] = useState(false);
  const pathname = location.pathname;
  const isAuthenticating = useRef(false);
  let role = localStorage.getItem("role") ? localStorage.getItem("role") : null;

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => console.log(err),
  });

  useEffect(() => {
    const storedRefreshToken = localStorage.getItem("refreshToken");
    const storedToken = localStorage.getItem("token");

    // If we have both tokens and headers are set, just load content
    if (storedToken && storedRefreshToken && client.headers?.Authorization) {
      setLoadContent(true);
      return;
    }

    // Prevent multiple simultaneous auth attempts
    if (isAuthenticating.current) {
      return;
    }

    // Otherwise, authenticate
    if (storedRefreshToken) {
      isAuthenticating.current = true;
      onRefreshToken(storedRefreshToken);
    } else {
      redirectToLogin();
    }
  }, [pathname]);

  useEffect(() => {
    console.log("loadContent:",loadContent);
  }, [loadContent]);

  const redirectToLogin = () => {
    if (isAuthenticating.current) return; // Prevent multiple redirects
    isAuthenticating.current = true;

    const nextUrl = pathname + window.location.search;
    if(nextUrl.includes(admin_string))
      navigate(`{admin_string}/signin/?next=${encodeURIComponent(nextUrl)}`, { replace: true });
    else
      navigate(`/signin/?next=${encodeURIComponent(nextUrl)}`, { replace: true });
  };

  const onRefreshToken = async (token) => {
    const { data, error } = await refreshToken({
      variables: { refreshToken: token },
    });

    isAuthenticating.current = false;

    if (error) {
      const message = error.graphQLErrors?.[0]?.message;
      if (
        message === "You do not have permission to perform this action" ||
        message === "Signature has expired" ||
        message === "Refresh token is expired" ||
        message === "Invalid refresh token"
      ) {
        redirectToLogin();
      }
      return;
    }

    if (data?.refreshToken) {
      console.log(data.refreshToken.token);
      localStorage.setItem("token", data.refreshToken.token);
      localStorage.setItem("refreshToken", data.refreshToken.refreshToken);
      localStorage.setItem("role", data.refreshToken.payload?.role || role);
      client.setHeader("Authorization", `JWT ${data.refreshToken.token}`);

      // Check admin access
      if(pathname.includes(admin_string) && data.refreshToken.payload?.role !== "Admin"){
        console.log("Unauthorized admin access");
        setLoadContent(false);
        navigate("/dashboard");
      } else {
        setLoadContent(true);
      }
    }
  };

  if (!loadContent) return null; // or a loading spinner

  return(
    <>{children}</>
  );
};

export default AuthWrapper;
